import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isUserLoggedIn } from './AuthService';

const PrivateUserRoute = ({ component: content, ...rest }) => (
      <Route
            render={({ location }) => {
                  if (isUserLoggedIn()) {
                        return <Route component={content} {...rest} />;
                  }
                  return <Redirect
                        to={{
                              pathname: "/login",
                              state: { from: location }
                        }}
                  />;
            }}
      />
);

export default PrivateUserRoute;